/* eslint-disable */

// import SkuPriceObjectClass from "./../NoppePriceHelper";
import requestConfigResult from "./requestConfigResult";

import getUrlParameter from "../helpers/getUrlParameter";

//let SkuPriceObjectClass = require('./SkuPrices.js');
let comStatus = {};
let callerCallBack;
let contextUsed;

const LFC_BACKEND_TEST_URL = process.env.REACT_APP_LFC_BACKEND_TEST_URL;
const LFC_BACKEND_LIVE_URL = process.env.REACT_APP_LFC_BACKEND_LIVE_URL;

export default class LfcEngine {
  // constructor(context, skuPricesObject, priceHelper, motherCallback) {
  constructor(context, priceHelper, pricingInfo, motherCallback, env, lfcMode) {
    this.baseRestUrl =
      env === "test"
        ? LFC_BACKEND_TEST_URL
        : LFC_BACKEND_LIVE_URL;

    this.lfcDimensions = null;
    this.constraintRuleset = null;
    this.skuGrossList = JSON.parse("[]");
    this.skuPriceList = JSON.parse("[]");
    this.partout = null;
    // TODO: remove?
    // this.skuPricesInstance = undefined
    this.getPricesForSkus = undefined;
    callerCallBack = motherCallback; // TODO: Jernis status på kommunikationen

    comStatus.context = {};
    comStatus.context.status = 200;
    comStatus.context.exectime = 0;
    comStatus.context.message = "OK";

    comStatus.dimension = {};
    comStatus.dimension.status = 0;
    comStatus.dimension.exectime = 0;
    comStatus.dimension.message = "";

    comStatus.constraints = {};
    comStatus.constraints.status = 0;
    comStatus.constraints.exectime = 0;
    comStatus.constraints.message = "";

    comStatus.prices = {};
    comStatus.prices.status = 0;
    comStatus.prices.exectime = 0;
    comStatus.prices.message = "";

    if (
      context &&
      typeof context === "string" &&
      priceHelper &&
      typeof priceHelper === "function"
    ) {
      LfcEngine.getPricesForSkus = priceHelper;
      this.context = context;
      contextUsed = context;

      this.getGrossList(this.setGrossListCallBack); // Load all the SKU:s for this context
      this.getInternalDimensions();
      this.getConstraintRuleSet(this.setConstraintRulesetCallBack);
    } else if (
      context &&
      typeof context === "string" &&
      (lfcMode === "WDW" || lfcMode === "DOOR") // window configurator
    ) {
      // LfcEngine.getPricesForSkus = priceHelper;
      this.context = context;
      contextUsed = context;
      this.pricingInfo = pricingInfo;

      // this.getGrossList(this.setGrossListCallBack); // Load all the SKU:s for this context
      this.getInternalDimensions();
      this.getConstraintRuleSet(this.setConstraintRulesetCallBack);
    } else {
      comStatus.context.status = 500;
      comStatus.context.exectime = 0;
      comStatus.context.message =
        "provided context, priceHelper and/or lfcMode is undefined.";
      callerCallBack(comStatus);
    }
  }

  // Expose these functions via an interface while hiding
  // the implementation of the module within the function() block
  getContext() {
    return this.context;
  }

  getSkuPrices() {
    return this.skuPriceList;
  }

  getComStatus() {
    return comStatus;
  }

  setConstraintRulesetCallBack(lfc) {
    // dont execute.
  }

  setContext(context) {
    this.getGrossList(this.setGrossListCallBack);
    LfcEngine.context = context;
  }

  // Gets all dimensions for this context
  setGrossListCallBack(json) {
    comStatus.prices.status = 0;
    LfcEngine.skuGrossList = json;
  }

  getGrossList(callBack) {
    const xhttp = new XMLHttpRequest();
    xhttp.open(
      "GET",
      `${this.baseRestUrl}/partout/grossskulist/${this.context}`,
      true
    );
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.timeout = 10000;
    LfcEngine.skuGrossList = JSON.parse("{}");
    xhttp.ontimeout = function (e) {
      LfcEngine.skuGrossList.comStatus = 408;
      LfcEngine.skuGrossList.comMessage = "Error Rest Timeout ";
      console.error(
        "Failed communications for skuGrossList",
        JSON.stringify(e)
      );
      callBack(LfcEngine.skuGrossList);
    };
    xhttp.onload = function () {
      const result = xhttp.responseText;
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        LfcEngine.skuGrossList = JSON.parse(result);
        LfcEngine.skuGrossList.comStatus = xhttp.status;
        LfcEngine.skuGrossList.comMessage = "OK";
        callBack(LfcEngine.skuGrossList);
      } else {
        LfcEngine.skuGrossList.comStatus = xhttp.status;
        LfcEngine.skuGrossList.comMessage = "Error rest service";
        console.error(`error${xhttp.responseType}`);
        callBack(LfcEngine.skuGrossList);
      }
    };
    xhttp.onError = function (e) {
      LfcEngine.skuGrossList.comStatus = 500;
      LfcEngine.skuGrossList.comMessage = "Server throw a generic error";
      console.error(`Generic server error`);
      callBack(LfcEngine.skuGrossList);
    };

    xhttp.send();
  }

  getDimensions() {
    return LfcEngine.lfcDimensions;
  }

  getInternalDimensions() {
    const publishedAll = getUrlParameter("published") === "all";

    comStatus.dimension.status = 0;
    const xhttp = new XMLHttpRequest();
    xhttp.open(
      "GET",
      `${this.baseRestUrl}/dimensions/${this.context}${
        publishedAll ? "?published=all" : ""
      }`,
      true
    );
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.timeout = 10000;
    LfcEngine.lfcDimensions = JSON.parse("{}");

    xhttp.ontimeout = function (e) {
      comStatus.dimension.status = 408;
      comStatus.dimension.exectime = 0;
      comStatus.dimension.message = "Error Rest Timeout ";

      console.error("Failed communications for dimensions", JSON.stringify(e));
      callerCallBack(comStatus);
    };
    xhttp.onload = function () {
      const result = xhttp.responseText;
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        LfcEngine.lfcDimensions = JSON.parse(result);
        if (LfcEngine.lfcDimensions.dimensions === undefined) {
          comStatus.context.status = 500;
          comStatus.context.exectime = 0;
          comStatus.context.message =
            "provided context " + contextUsed + " is invalid.";
        } else {
          comStatus.context.status = 200;
          comStatus.context.exectime = 0;
          comStatus.context.message = "OK";
        }

        comStatus.dimension.status = xhttp.status;
        comStatus.dimension.exectime = 0;
        comStatus.dimension.message = "OK";

        callerCallBack(comStatus);
      } else {
        comStatus.dimension.status = xhttp.status;
        comStatus.dimension.exectime = 0;
        comStatus.dimension.message = "Error rest service";

        console.error(`error${xhttp.responseType}`);
        callerCallBack(comStatus);
      }
    };
    xhttp.onError = function (e) {
      comStatus.dimension.status = 500;
      comStatus.dimension.exectime = 0;
      comStatus.dimension.message = "Server throw a generic error";

      console.error(`Generic server error`);

      callerCallBack(comStatus);
    };

    xhttp.send();
  }

  getConstraintRuleSet(callBack) {
    comStatus.constraints.status = 0;
    const xhttp = new XMLHttpRequest();
    xhttp.open(
      "GET",
      `${this.baseRestUrl}/constraints/rules/${this.context}`,
      true
    );
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.timeout = 10000;
    LfcEngine.constraintRuleset = JSON.parse("{}");
    xhttp.ontimeout = function (e) {
      console.error(
        "Failed communications for constraint rules",
        JSON.stringify(e)
      );
      comStatus.constraints.status = 408;
      comStatus.constraints.exectime = 0;
      comStatus.constraints.message = "Error Rest Timeout ";

      callBack(LfcEngine.constraintRuleset);
      callerCallBack(comStatus);
    };

    xhttp.onload = function () {
      const result = xhttp.responseText;
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        LfcEngine.constraintRuleset = JSON.parse(result);

        comStatus.constraints.status = xhttp.status;
        comStatus.constraints.exectime = 0;
        comStatus.constraints.message = "OK";

        callBack(LfcEngine.constraintRuleset);
        callerCallBack(comStatus);
      } else {
        comStatus.constraints.status = xhttp.status;
        comStatus.constraints.exectime = 0;
        comStatus.constraints.message = "Error rest service";

        console.error(`error${xhttp.responseType}`);
        callBack(LfcEngine.constraintRuleset);
        callerCallBack(comStatus);
      }
    };

    xhttp.onError = function (e) {
      comStatus.constraints.status = 500;
      comStatus.constraints.exectime = 0;
      comStatus.constraints.message = "Server throw a generic error";
      console.error(`Generic server error`);
      callBack(LfcEngine.constraintRuleset);
      callerCallBack(comStatus);
    };

    xhttp.send();
  }

  getConfigResult(callBack, selectedValues, marketCode) {
    requestConfigResult(
      this.baseRestUrl,
      this.context,
      marketCode,
      selectedValues,
      this.pricingInfo,
      callBack,
      callerCallBack,
      comStatus
    );
  }

  getSkuForParts(callBack, partsArray) {
    comStatus.prices.status = 0;
    if (partsArray === null) {
      console.log("Missing parts to lookup? returning null..");
      return null;
    }
    const xhttp = new XMLHttpRequest();
    xhttp.open(
      "POST",
      `${this.baseRestUrl}/partout/skulist/v2/${this.context}`,
      true
    );
    xhttp.setRequestHeader("Content-type", "application/json");
    xhttp.timeout = 10000;
    LfcEngine.partout = JSON.parse("{}");
    xhttp.ontimeout = function (e) {
      comStatus.prices.status = 408;
      comStatus.prices.exectime = 0;
      comStatus.prices.message = "Error Rest Timeout ";
      callBack(LfcEngine.partout);
      callerCallBack(comStatus);
    };
    xhttp.onload = function () {
      const result = xhttp.responseText;
      if (xhttp.readyState === 4 && xhttp.status === 200) {
        comStatus.prices.status = xhttp.status;
        comStatus.prices.exectime = 0;
        comStatus.prices.message = "OK";

        const { partOut, ...metaInfo } = JSON.parse(result);
        populateListWithPrices(callBack, partOut, metaInfo);
        callerCallBack(comStatus);
      } else {
        comStatus.prices.status = xhttp.status;
        comStatus.prices.exectime = 0;
        comStatus.prices.message = "Error rest service";
        console.error(`error${xhttp.responseType}`);
        callBack(LfcEngine.partout);
        callerCallBack(comStatus);
      }
    };
    xhttp.onError = function (e) {
      comStatus.prices.status = 500;
      comStatus.prices.exectime = 0;
      comStatus.prices.message = "Server throw a generic error";

      console.error(`Generic server error`);
      callBack(LfcEngine.partout);
      callerCallBack(comStatus);
    };

    // execute the request
    xhttp.send(JSON.stringify({ chosenValues: partsArray }));

    // Function to get prices from priceHelper
    function populateListWithPrices(callingCallback, json, metaInfo) {
      LfcEngine.getPricesForSkus(setSkuPricesCallBack, json);
      function setSkuPricesCallBack(skuPrices) {
        LfcEngine.skuPriceList = {};
        if (skuPrices.length > 0) {
          skuPrices.forEach(function (sku) {
            let data = {};
            data.priceRed = sku.redprice;
            data.priceBlack = sku.listprice;
            data.buyAble = sku.buyable;
            data.deliverWeek = sku.deliverweek;
            data.title = sku.title;
            data.titlelong = sku.titlelong;
            data.description = sku.description;
            data.qty = sku.qty;
            LfcEngine.skuPriceList[sku.sku] = data;
          });
        }
        comStatus.prices.status = skuPrices.comStatus;
        comStatus.prices.exectime = skuPrices.comExecTime;
        comStatus.prices.message = skuPrices.comMessage;
        callerCallBack(comStatus);

        // skuPrices
        LfcEngine.partout = skuPrices;
        callingCallback(LfcEngine.partout, metaInfo);
      }
    }
  }

  checkConstraint(selectedValues) {
    const DENYFOR = "DENYFOR";
    const NEEDSANYOF = "NEEDSANYOF";
    const RECOMMENDED = "recommendedFor";
    let ruleCheckResult = new Array();
    let ruleHolder = new Array();
    let masterRuleFound = 0;

    LfcEngine.constraintRuleset.rules.forEach(function (rule) {
      let conCatHolder = new Array();
      ruleHolder =
        '{"ruleId":' + rule.ruleId + ',"valueId":' + rule.valueId + ",";
      let t = ckon(rule, selectedValues, "needConditions", NEEDSANYOF);
      if (t !== undefined) conCatHolder.push(t);
      t = ckon(rule, selectedValues, "denyForConditions", DENYFOR);
      if (t !== undefined) conCatHolder.push(t);
      conCatHolder.push(
        ckon(rule, selectedValues, "recommendedForConditions", RECOMMENDED)
      );
      ruleHolder = ruleHolder + conCatHolder + "}";
      ruleCheckResult.push(ruleHolder);
    });

    function ckon(rule, selVals, type, name) {
      let vs = new Array();
      let rval = undefined;
      let currentRule = rule[type];
      let foundRule = 0;

      currentRule.forEach(function (rule) {
        if (rule.type === "AND") {
          selVals.forEach(function (selectedValue) {
            if (lookupId(rule.valueIdList, selectedValue)) {
              vs.push(
                '{"type": "AND", "valueIdList":' +
                  JSON.stringify(rule.valueIdList) +
                  "}"
              );
              foundRule = 1;
              masterRuleFound = 1;
            }
          });
        } else if (rule.type === "SINGLE") {
          selVals.forEach(function (selectedValue) {
            if (lookupId(rule.valueId, selectedValue)) {
              vs.push(
                '{"type": "SINGLE", "valueId":' +
                  JSON.stringify(rule.valueId) +
                  "}"
              );
              foundRule = 1;
              masterRuleFound = 1;
            }
          });
        }
      });

      if (foundRule === 1) {
        rval = new Array();
        rval.push('"checkStatus":' + '"' + name + '"');
        rval.push('"decisionConditions":[' + vs + "]");
      } else if (foundRule === 0 && type === "recommendedForConditions") {
        rval = new Array();
        if (masterRuleFound === 0) {
          rval.push('"checkStatus":' + '"OK"');
          rval.push('"decisionConditions":[]');
        }
        rval.push('"' + name + '":' + "{}");
      }

      return rval;
    }

    function lookupId(valueIdList, selectedValue) {
      if (valueIdList.isArray) {
        if (valueIdList.indexOf(selectedValue)) {
          return true;
        }
      } else {
        if (valueIdList === selectedValue) {
          return true;
        }
      }
      return false;
    }

    if (ruleCheckResult.length < 1) {
      return JSON.parse("[]");
    } else {
      return JSON.parse("[" + ruleCheckResult + "]");
    }
  }
}
